/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import { workService } from "../views/Works/services";
import { constants } from "../shared/constants";
import { router } from "../plugins/vue-router";
import Vue from "vue";
import _ from "lodash";
import { ReportingService } from "../views/Reporting/services";

const state = {
  works: [],
  work: {},
  messageries: [],
  operation: {},
  operations: {},
  lots: {},
  workCount: 0,
  operationsCount: 0,
  totalVolume: 0,
  applicationSector: {},
  applicationSectorType: {},
  workOperations: {}
};
const getters = {
  getWorks: state => state.works,
  getMessageries: state => state.messageries,
  getWork: state => state.work,
  getOperation: state => state.operation,
  getOperations: state => state.operations,
  getWorkOperations: state => state.workOperations,
  getApplicationSector: state => state.applicationSector,
  getApplicationSectorType: state => state.applicationSectorType,
  getLots: state => state.lots,
  getWorkCount: state => state.workCount,
  getOperationsCount: state => state.operationsCount,
  getTotalVolume: state => state.totalVolume
};
const actions = {
  getWorksAction(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    workService
      .fetchWorks(currentPage, perPage, sortBy, sortDir, customFilter, search)
      .then(
        result => {
          commit("setWorks", result);
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  getWorksAdminAgence(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, agenceId }
  ) {
    workService
      .fetchWorksAdminAgence(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        agenceId
      )
      .then(
        result => {
          commit("setWorks", result);
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  getWorksChargeDeProjet(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    workService
      .fetchWorksChargeDeProjet(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search
      )
      .then(
        result => {
          commit("setWorks", result);
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  getWorksChargeDeProjetById(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, userId }
  ) {
    workService
      .fetchWorksChargeDeProjetById(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        userId
      )
      .then(
        result => {
          commit("setWorks", result);
        },
        error => {
          console.log(error);
        }
      );
  },
  getMessageriesAction({ commit }, { refClientId, loaded }) {
    workService.fetchWorkMessageries(refClientId, loaded).then(
      result => {
        commit("setMessageries", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  submitAnswerAction(
    { commit, dispatch },
    { questionId, MessagerieAnswerDto, workId }
  ) {
    workService.submitAnswer(questionId, MessagerieAnswerDto).then(
      answer => {
        dispatch("getMessageriesAction", { refClientId: workId, loaded: true });
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  submitModifiedAnswerAction(
    { commit, dispatch },
    { questionId, MessagerieAnswerDto, workId }
  ) {
    workService.submitModifiedAnswer(questionId, MessagerieAnswerDto).then(
      nesAnswer => {
        dispatch("getMessageriesAction", { refClientId: workId, loaded: true });
        dispatch("getMessageriesAction");
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  deleteAnswerAction({ commit, dispatch }, { questionId, historyId, workId }) {
    workService.deleteAnswer(questionId, historyId).then(
      result => {
        dispatch("getMessageriesAction", { refClientId: workId, loaded: true });
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  getWorkByIdAction({ commit }, { id }) {
    workService.fetchWorkById(id).then(
      result => {
        commit("setWork", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
    workService.fetchWorkMessageries(id).then(
      result => {
        commit("setMessageries", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getWorkOperationsByWorkIdAction(
    { commit },
    { id, currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    workService
      .fetchWorkOperationsByWorkId(
        id,
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search
      )
      .then(
        result => {
          commit("setOperations", result);
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  getAllWorkOperations(
    { commit },
    { id, currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    workService
      .fetchAllWorkOperations(
        id,
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search
      )
      .then(
        result => {
          commit("setWorkOperations", result);
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  getWorkLotsAction(
    { commit },
    { id, currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    workService
      .fetchWorkLots(
        id,
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search
      )
      .then(
        result => {
          commit("setLots", result);
        },
        error => {
          Vue.$log.error(error);
        }
      );
  },
  getOperationByIdAction({ commit }, { idWork, idOperation }) {
    workService.fetchWorkOperation(idWork, idOperation).then(
      result => {
        if (result) {
          commit("setOperation", result);
          const appSector = constants.APPLICATION_SECTORS.find(
            el => el.value === state.operation.fiche.applicationSector
          );
          const type = appSector.types.find(
            el => el.value === state.operation.fiche.type
          );
          commit("setApplicationSector", appSector);
          commit("setApplicationSectorType", type);
        } else {
          Vue.prototype.$notification.error("Opération non trouvée");
          router.push({ name: "WorkDetail", params: { id: idWork } });
        }
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getWorkCountAction({ commit }) {
    workService.fetchWorkCount().then(
      result => {
        commit("setWorkCount", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getWorkCountActionAdminAgence({ commit }, { agenceId }) {
    workService.fetchWorkCountAdminAgence(agenceId).then(
      result => {
        commit("setWorkCount", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getWorkCountActionChargeDeProjet({ commit }) {
    workService.fetchWorkCountChargeDeProjet().then(
      result => {
        commit("setWorkCount", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  getWorkOperationsCountAction({ commit }) {
    workService.fetchWorkOperationsCount().then(
      result => {
        commit("setOperationsCount", result);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },

  getTotalVolume({ commit }) {
    ReportingService.getWorkVolumeReport().then(
      result => {
        commit("setTotalVolume", result.classic + result.precarity);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getTotalVolumeAdminAgence({ commit }, { agenceId }) {
    ReportingService.getWorkVolumeReportAdminAgence(agenceId).then(
      result => {
        commit("setTotalVolume", result.classic + result.precarity);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  },
  getTotalVolumeChargeDeProjet({ commit }) {
    ReportingService.getWorkVolumeReportChargeDeProjet().then(
      result => {
        commit("setTotalVolume", result.classic + result.precarity);
      },
      error => {
        Vue.$log.error(error);
      }
    );
  }
};
const mutations = {
  setWorks(state, val) {
    state.works = val;
  },
  setMessageries(state, val) {
    let index = 0;
    state.messageries = _.map(val, function(element) {
      return _.extend({}, element, {
        shown: false,
        index: index++,
        shouldLoading: false
      });
    });
  },
  setShouldLoading(state, val) {
    state.messageries.forEach(msg => {
      if (msg.id === val) {
        msg.shouldLoading = true;
      }
    });
  },
  setShouldNotLoading(state, val) {
    state.messageries.forEach(msg => {
      if (msg.id === val) {
        msg.shouldLoading = false;
      }
    });
  },
  setWork(state, val) {
    state.work = val;
  },
  setOperation(state, val) {
    state.operation = val;
  },
  setOperations(state, val) {
    state.operations = val;
  },
  setWorkOperations(state, val) {
    state.workOperations = val;
  },
  setApplicationSector(state, val) {
    state.applicationSector = val;
  },
  setApplicationSectorType(state, val) {
    state.applicationSectorType = val;
  },
  setLots(state, val) {
    state.lots = val;
  },
  setWorkCount(state, val) {
    state.workCount = val;
  },
  setTotalVolume(state, val) {
    state.totalVolume = val;
  },
  setOperationsCount(state, val) {
    state.operationsCount = val;
  }
};

export const work = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
